import { useState } from 'react';
import type { LegalDocumentSummary } from '../types';
import { LegalDocumentText } from './LegalDocumentText';

export function AgreementGate({
  document,
  participantName,
  initialTypedName = '',
  onAccept,
}: {
  document: LegalDocumentSummary;
  participantName: string;
  initialTypedName?: string;
  onAccept: (typedName: string) => Promise<void>;
}) {
  const [checked, setChecked] = useState(false);
  // Suggest the Step 1 signature, but still require a distinct agreement and click.
  const [typedName, setTypedName] = useState(initialTypedName);
  const [working, setWorking] = useState(false);
  const [error, setError] = useState('');

  async function accept() {
    if (!checked || typedName.trim().length < 2) return;
    setWorking(true);
    setError('');
    try {
      await onAccept(typedName.trim());
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Unable to record acceptance.');
    } finally {
      setWorking(false);
    }
  }

  return (
    <section className="gate-shell">
      <div className="eyebrow">ONE MORE STEP</div>
      <h1>Your story is almost ready.</h1>
      <p className="lede">{participantName}, you’re almost there. Your private ROAM page is a first look at your story. Please read these access terms and sign with your full legal name to open it. They explain how to keep unreleased previews private and are separate from any optional Media Select license.</p>
      <div className="agreement-card">
        <div className="agreement-card__header">
          <div><strong>{document.name}</strong><span>Version {document.version}</span></div>
          <span className="pill">Private page · Step 2</span>
        </div>
        <div className="agreement-copy">
          <LegalDocumentText body={document.body} />
        </div>
      </div>
      <label className="legal-name-field">Typed legal name<input value={typedName} onChange={(e) => setTypedName(e.target.value)} placeholder="Your full legal name" /></label>
      <label className="consent-row">
        <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
        <span>I have read and agree to the {document.name} shown above.</span>
      </label>
      {error && <p className="error">{error}</p>}
      <button className="button button--light button--wide" disabled={!checked || typedName.trim().length < 2 || working} onClick={accept}>
        {working ? 'Saving your signature…' : 'I ACCEPT — open my feature'}
      </button>
      <p className="microcopy">We’ll save your signed agreement and the date you accepted it. You won’t need to sign this version again each time you visit.</p>
    </section>
  );
}
